/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Pay_Later_BadgeInputs */

const en_admin_external_booking_edit_pay_later_badge = /** @type {(inputs: Admin_External_Booking_Edit_Pay_Later_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay later`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Pay_Later_BadgeInputs) => LocalizedString} */
const de_admin_external_booking_edit_pay_later_badge = en_admin_external_booking_edit_pay_later_badge;

/** @type {(inputs: Admin_External_Booking_Edit_Pay_Later_BadgeInputs) => LocalizedString} */
const es_admin_external_booking_edit_pay_later_badge = en_admin_external_booking_edit_pay_later_badge;

/** @type {(inputs: Admin_External_Booking_Edit_Pay_Later_BadgeInputs) => LocalizedString} */
const fr_admin_external_booking_edit_pay_later_badge = en_admin_external_booking_edit_pay_later_badge;

/** @type {(inputs: Admin_External_Booking_Edit_Pay_Later_BadgeInputs) => LocalizedString} */
const it_admin_external_booking_edit_pay_later_badge = en_admin_external_booking_edit_pay_later_badge;

/** @type {(inputs: Admin_External_Booking_Edit_Pay_Later_BadgeInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_pay_later_badge = en_admin_external_booking_edit_pay_later_badge;

/** @type {(inputs: Admin_External_Booking_Edit_Pay_Later_BadgeInputs) => LocalizedString} */
const pl_admin_external_booking_edit_pay_later_badge = en_admin_external_booking_edit_pay_later_badge;

/** @type {(inputs: Admin_External_Booking_Edit_Pay_Later_BadgeInputs) => LocalizedString} */
const hu_admin_external_booking_edit_pay_later_badge = en_admin_external_booking_edit_pay_later_badge;

/** @type {(inputs: Admin_External_Booking_Edit_Pay_Later_BadgeInputs) => LocalizedString} */
const ro_admin_external_booking_edit_pay_later_badge = en_admin_external_booking_edit_pay_later_badge;

/**
* | output |
* | --- |
* | "Pay later" |
*
* @param {Admin_External_Booking_Edit_Pay_Later_BadgeInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_pay_later_badge = /** @type {((inputs?: Admin_External_Booking_Edit_Pay_Later_BadgeInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Pay_Later_BadgeInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_pay_later_badge(inputs)
	if (locale === "de") return de_admin_external_booking_edit_pay_later_badge(inputs)
	if (locale === "es") return es_admin_external_booking_edit_pay_later_badge(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_pay_later_badge(inputs)
	if (locale === "it") return it_admin_external_booking_edit_pay_later_badge(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_pay_later_badge(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_pay_later_badge(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_pay_later_badge(inputs)
	return ro_admin_external_booking_edit_pay_later_badge(inputs)
});
export { admin_external_booking_edit_pay_later_badge as "admin.external_booking_edit.pay_later_badge" }